<div *ngIf="id" class="form-group m-form__group m-form__group--colored m--margin-top-15 m--padding-15">
  <div *ngIf="!isLoading.list" class="m--padding-left-15 m--padding-right-15">
    <h5 class="m--margin-bottom-15">{{ 'representatives-new.representatives' | transloco }}</h5>

    <div class="is--highlights" *ngFor="let item of list; let i = index">
      <div class="row m--padding-bottom-15">
        <div class="col-lg-4 col-md-4 col-sm-12">
          <input type="text" class="form-control m-input" [(ngModel)]="list[i].name" (focusout)="updateData(item)" [placeholder]="'representatives-new.name' | transloco">
        </div>

        <div class="col-lg-5 col-md-5 col-sm-12">
          <div class="input-group">
            <input type="text" class="form-control m-input" [(ngModel)]="list[i].position" (focusout)="updateData(item)" [placeholder]="'representatives-new.position' | transloco">

            <span class="input-group-btn">
              <button (click)="removeField(item, i)" class="btn btn-danger btn-thin" type="button">
                <i class="la la-trash"></i>
              </button>
            </span>
          </div>
        </div>

        <div class="col-lg-3 col-md-3 col-sm-12">
          <button *ngIf="item?.id" (click)="addContacts(i)" class="btn btn-outline-success m-btn--icon" type="button">
            <span>{{ 'representatives-new.addContacts' | transloco }}</span>
          </button>
        </div>
      </div>

      <div *ngIf="!item?.id">
        <div role="alert" class="l-content-width we-banner">
          <div class="we-banner__copy">{{ 'representatives-new.info' | transloco }}</div>
        </div>
      </div>

      <ng-container *ngIf="item?.id">
        <h6 class="m--margin-bottom-15" *ngIf="item?.contacts?.length">{{ 'representatives-new.contact' | transloco }} {{ list[i].name }}</h6>

        <div class="row m--padding-bottom-15" *ngFor="let contact of item?.contacts; let a = index">
          <div class="col-lg-4 col-md-4 col-sm-12">
            <select [(ngModel)]="list[i].contacts[a].type" class="form-control m-input m-input--square">
              <option value="">{{ 'representatives-new.noChoose' | transloco }}</option>
              <option *ngFor="let item of types" [value]="item">{{ 'suppliers.representative.type.' + item | transloco }}</option>
            </select>
          </div>

          <div class="col-lg-5 col-md-5 col-sm-12">
            <div *ngIf="list[i].contacts[a].type" class="input-group">
              <!-- TODO add phone mask -->
              <input *ngIf="list[i].contacts[a].type === 'PHONE'" type="text" class="form-control m-input" [(ngModel)]="list[i].contacts[a].value" (focusout)="updateContact(contact, item?.id)" [placeholder]="'representatives-new.contacts' | transloco">
              <input *ngIf="list[i].contacts[a].type === 'EMAIL'" type="text" class="form-control m-input" [(ngModel)]="list[i].contacts[a].value" (focusout)="updateContact(contact, item?.id)" [placeholder]="'representatives-new.contacts' | transloco">

              <span class="input-group-btn">
                <button (click)="removeContact(contact, i, a)" class="btn btn-danger btn-thin" type="button">
                  <i class="la la-trash"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="text-right">
      <button (click)="addItem()" class="btn btn-success m-btn--icon" type="button">
        <span>
          <i class="la la-plus"></i>
          <span>{{ 'representatives-new.addRepresentative' | transloco }}</span>
        </span>
      </button>
    </div>
  </div>

  <div *ngIf="isLoading.list" class="m-page-loader m-page-loader--non-block m-page-loader--relative">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>

